import * as React from "react";

import "./eddm.scss";

import {cs}             from "@Common/react/chain-services";
import {UseState}       from "@Common/react/use-state";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";

import {ConfirmCancel} from "../common/confirm-cancel";
import {WizardControl} from "../common/wizard-control";

import {Step1SelectTarget} from "./step-1-select-target/step-1-select-target";
import {MapStep}           from "./map-step/map-step"
import {Step2Routes}       from "./step-2-routes/step-2-routes";

import {isDevQuan} from "debug/is-dev-quan";

export const Eddm = ({onClose, onCreated, onCancel, cancelLabel="Cancel", entityId, next}) => cs(
    consumeContext("apis"),
    //consumeContext("company"),
    ["state", (_, next) => UseState({
        // initValue: isDevQuan() ? {
        //     allRoutes: require("../../../../../../apis/next/mailing/eddm/sample-eddm-search"),
        //     searchRequestServerKey: "ABC",
        // }:undefined,
        next,
    })],
    ["confirmCancel", (_, next) => ConfirmCancel({next})],
    //["step1", (_, next) => Step1SelectTarget({next})],
    ["mapStep", ({state}, next) => MapStep({state, next})],
    ["step2", ({state}, next) => Step2Routes({state, next})],
    ["wizardControl", ({mapStep, step2, apis}, next) => WizardControl({
        steps: [
            // !company?.prefs?.enableMapBasedMailingSupport ? {
            //     render: ({resetNav}) => (
            //         step1.render({
            //             onNext: async () => {
            //                 await step2.prepare(step1.getSearchRequest());

            //                 resetNav();
            //             },
            //             onCancel,
            //             cancelLabel,
            //         })
            //     ),
            //     name: "step1",
            // } : 
            {
                render: ({resetNav}) => (
                    mapStep.render({
                        onNext: async ({unselectedRoutes}) => {
                            step2.setUnselecteds({unselectedRoutes});
                            resetNav();
                        },
                        onCancel,
                        cancelLabel,
                    })
                ),
                name: "mapStep",
            },
            {
                condition: () => step2.ready && mapStep.done,
                render: ({goBack}) => (
                    step2.render({
                        onBack: ({selectedRoutes}) => {
                            mapStep.prepareSelecteds({selectedRoutes});
                            goBack();
                        },
                        onComplete: async (data) => {
                            const result = await apis.next.mailing.eddm.createEddmList({...data, entityId});

                            if (result.result === "failure") {
                                alert(result.errors?.msg ?? "Unknown error");
                            } else {
                                onCreated([result.mailingListId], {autoSelect: true});

                                onClose();
                            }
                        },
                    })
                ),
                name: "step2",
            },
        ].filter(v=>v),
        next,
    })],
    ({confirmCancel, wizardControl}) => (
        next({
            onPassiveClose: confirmCancel,
            content: cs(
                keyed(wizardControl.currentStep.index),
                () => wizardControl.currentStep.render(),
            ),
            ...(wizardControl.currentStep.name === "mapStep" ? {
                width: 1200,
                top: 10,
                bottom: 10,
            } : {}),
        })
    )
);
